module.exports = __webpack_public_path__ + "static/media/RJ.8246e486.jpg";